// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__AsdYo","description":"PatientConsentPreview_description__1Wayl"};